import {
    inboxBriefingMorningCommandText,
    inboxBriefingEveningCommandText,
} from './getInboxBriefing.locstring.json';
import { isEveningBriefing } from './currentTimeCheckUtils';
import loc, { type LocalizedString } from 'owa-localize';
import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { getCustomCopilotExperiment } from 'owa-copilot-experiment-utils/lib/getCustomCopilotExperiment';
import { CopilotExperimentKeys } from 'owa-copilot-experiment-utils/lib/copilotExperimentKeys';

/**
 * Helper function to determine which inbox briefing command to use based on current time.
 * When the debug flight is on, returns the custom experiment prompt if set, otherwise the default.
 */
export function getInboxBriefingCommandText(mailboxInfo: MailboxInfo): LocalizedString {
    const isEvening = isEveningBriefing();
    const isDebug =
        isGlobalFeatureEnabled('mon-copilot-inbox-briefings') &&
        isGlobalFeatureEnabled('mon-copilot-inbox-briefings-debug');

    if (isDebug) {
        const experimentKey = isEvening
            ? CopilotExperimentKeys.InboxBriefingsEvening
            : CopilotExperimentKeys.InboxBriefingsMorning;
        const customPrompt = getCustomCopilotExperiment(experimentKey, mailboxInfo);
        if (customPrompt) {
            return customPrompt as LocalizedString;
        }
    }

    return isEvening ? loc(inboxBriefingEveningCommandText) : loc(inboxBriefingMorningCommandText);
}
